import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import { NONCE_POOL_SIZE } from '../constants';
import { fetchAndStoreNonces } from '../fetchAndStoreNonces/fetchAndStoreNonces';

export const prefetchNoncesIfNeeded = async (
  client: DynamicClient
): Promise<void> => {
  const core = getCore(client);

  if (core.state.get().prefetchedNonces.length >= NONCE_POOL_SIZE) {
    return;
  }

  await fetchAndStoreNonces(client);
};
